import { FlagIcon } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  cycleStartDateWrapper: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '-0.084px',
    paddingRight: '8px',
    marginBottom: '24px',
  },
});

const CycleStartDate = ({ user }) => {
  const classes = useStyles();
  const dateOptions = { month: 'long', day: '2-digit' };
  return (
    <div className={classes.cycleStartDateWrapper}>
      {user?.site?.transactionCycle && (
        <span className="cycle-start-date">
          <FlagIcon /> Cycle Start: {new Date(user.site.transactionCycle.startedAt).toLocaleDateString('en-US', dateOptions)}
        </span>
      )}
    </div>
  );
};

CycleStartDate.propTypes = {
  user: PropTypes.object.isRequired,
};

export default CycleStartDate;
